import { BOOKING } from '../bookings/BookingContext'
import { fetchBookingsListing } from '../api/booking'
import { DateTime } from 'luxon'
/*
*/

export const BOOKING_STATES =  {
  OPEN: 'Open',
  BOUNCE_BACK_OPEN: 'Bounce Back Open',
  PENDING_BOOKING_INFO: 'Pending Booking Info',
  SENT_TO_VENDOR: 'Sent to Vendor',
  PROBLEM: 'Problem',
  BOOKED_PENDING_TOUR_INFO: 'Booked Pending Tour Info',
  BOOKED: 'Booked',
  TOUR_CLOSED: 'Tour/Closed',
  ON_HOLD: 'On Hold',
  BALANCE_DUE: 'Balance Due',
  CANCELLED: 'Cancelled',
  DO_NOT_SERVICE: 'DO NOT SERVICE',
  TBS_2020: 'TBS 2020',
  EXPIRED: 'Expired',
  NO_SHOW: 'No Show',
  QUALIFIED: 'Qualified (Q)',
  NOT_QUALIFIED: 'Not Qualified (NQ)',
  CANCELLATION_REQUESTED: 'Cancellation Requested',
}

const ERROR_STATES = [
  BOOKING_STATES.PROBLEM,
  BOOKING_STATES.CANCELLED,
  BOOKING_STATES.DO_NOT_SERVICE,
  BOOKING_STATES.EXPIRED,
  BOOKING_STATES.NO_SHOW,
  BOOKING_STATES.NOT_QUALIFIED
]

const WARNING_STATES = [
  BOOKING_STATES.CANCELLATION_REQUESTED,
  BOOKING_STATES.PENDING_BOOKING_INFO,
  BOOKING_STATES.SENT_TO_VENDOR,
  BOOKING_STATES.ON_HOLD,
  BOOKING_STATES.BALANCE_DUE,
  BOOKING_STATES.TBS_2020
]

const SUCCESS_STATES = [
  BOOKING_STATES.BOOKED,
  BOOKING_STATES.TOUR_CLOSED,
  BOOKING_STATES.QUALIFIED
]

const NOTICE_STATES = [
  BOOKING_STATES.OPEN,
  BOOKING_STATES.BOUNCE_BACK_OPEN,
  BOOKING_STATES.BOOKED_PENDING_TOUR_INFO
]

export const fetchBookingsAction = (dispatch, pageNum = 1, filterVal = "") => {
  dispatch({ type: BOOKING.LOADING, payload: true })
  //dispatch({ type: BOOKING.ALL, payload: null })
  fetchBookingsListing(pageNum, filterVal).then((response) => {
    dispatch({ type: BOOKING.ALL, payload: response.data.bookings })
    dispatch({ type: BOOKING.META, payload: response.data.meta })
  }).finally(() => {
    dispatch({ type: BOOKING.LOADING, payload: false })
  })
}

export const isBookingCancellable = (booking) => {
  const arrivalCutOff = DateTime.fromFormat(`${booking.arrival}T14:00:00 America/Denver`, "yyyy-MM-dd'T'HH:mm:ss z")
  const currentDateTime = DateTime.local()
  return ![BOOKING_STATES.CANCELLED, BOOKING_STATES.CANCELLATION_REQUESTED].includes(booking.status) && (currentDateTime < arrivalCutOff)
}

export const getBookingStatus = (booking) => {
  if (booking.status === BOOKING_STATES.PENDING_BOOKING_INFO) {
    return 'Pending'
  } else {
    return booking.status
  }
}

// return alert status class for color
export const getBookingStatusColor = status => {
  if (ERROR_STATES.includes(status)) {
    // red
    return "error"
  } else if (WARNING_STATES.includes(status)) {
    // yellow
    return "warning"
  } else if (SUCCESS_STATES.includes(status)) {
    // green
    return "success"
  } else if (NOTICE_STATES.includes(status)) {
    // blue
    return "notice"
  } else {
    // blue
    return "notice"
  }
}

export const normalizeBookingPayload = payload => {
  return payload.map((booking) => ({
    id: booking.id,
    arrival: booking.arrival,
    departure: booking.departure,
    destination: booking.destination,
    first_name: booking.first_name,
    last_name: booking.last_name,
    amount_of_adults: booking.amount_of_adults,
    property: booking.property,
    package_price: booking.package_price,
    status: booking.status,
    tour_confirmation_code: booking.lead && booking.lead.tour_confirmation_code,
    scheduled_tour_date: booking.lead && booking.lead.scheduled_tour_date,
    scheduled_tour_time: booking.lead && booking.lead.scheduled_tour_time,
    preview_center: booking.lead && booking.lead.confirmed_lv_tour,
    lodging_confirmation_code: booking.lodging_confirmation_code,
    cancellation_policies: booking.cancellation_policies
  }))
}
